export const COMMANDS_FULFILLED = 'COMMANDS_FULFILLED';
export const COMMANDS_REJECTED = 'COMMANDS_REJECTED';
export const COMMANDS_REQUEST = 'COMMANDS_REQUEST';

// Rules
export const EPS_LIST = 'EPS_LIST';
export const EPS_REGISTER = 'EPS_REGISTER';
export const EPS_LIST_CSV = 'EPS_LIST_CSV';
export const EPS_VIEW = 'EPS_VIEW';
export const EPS_EDIT = 'EPS_EDIT';
export const MASTER = 'MASTER';
export const MAILING_LIST = 'MAILING_LIST';
export const MAILING_REGISTER = 'MAILING_REGISTER';
export const MAILING_EDIT = 'MAILING_EDIT';
export const MAILING_VIEW = 'MAILING_VIEW';
export const MAILING_INACTIVATE = 'MAILING_INACTIVATE';
export const PREVIEW_LIST = 'PREVIEW_LIST';
export const PREVIEW_CREATE = 'PREVIEW_CREATE';
export const PREVIEW_VIEW = 'PREVIEW_VIEW';
export const PREVIEW_ACCEPT = 'PREVIEW_ACCEPT';
